<h3>{{ 'referentiels.list.prestationProperties.typePrestation.header' | transloco }}</h3>

@if (userHasReadWritePermission) {
  <div class="flex justify-content-between flex-wrap my-1">
    <div class="flex gap-2">
      <div class="flex justify-content-start gap-2 mb-1">
        <p-button [size]="'small'" label="{{ 'button.add' | transloco }}" pRipple [rounded]="true" class="btn-light" icon="pi pi-plus" (click)="addNewTypePrestation()" />
      </div>
    </div>
  </div>
}
<div class="card" [formGroup]="typePrestationForm">
  <p-table
    #prestationTable
    [(selection)]="selectedTypePrestation"
    [value]="typePrestationFormArray.controls"
    styleClass="p-datatable-striped"
    selectionMode="single"
    editMode="row"
    dataKey="value.id"
    [totalRecords]="typePrestationTotalRecords"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{{'jgrid.defaults.recordtext' | transloco}} {first} - {last} {{'jgrid.defaults.recordtextOf' | transloco}} {totalRecords}"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 5%"></th>
        <th pSortableColumn="value.codeHecate" style="width: 5%">{{'referentiels.list.typePrestationProperties.codeHecate.header' | transloco }} <p-sortIcon field="value.codeHecate" /></th>
        <th pSortableColumn="value.designation" style="width: 15%">{{'referentiels.list.typePrestationProperties.designation.header' | transloco }} <p-sortIcon field="value.designation" /></th>
        <th pSortableColumn="value.transport" style="width: 15%">{{'referentiels.list.typePrestationProperties.transport.header' | transloco }} <p-sortIcon field="value.transport" /></th>
        <th pSortableColumn="value.suffisantPourDemande" style="width: 10%">{{'referentiels.list.typePrestationProperties.suffisantPourDemande.header' | transloco }} <p-sortIcon field="value.suffisantPourDemande" /></th>
        <th pSortableColumn="value.afficherSurLaConfirmation" style="width: 10%">{{'referentiels.list.typePrestationProperties.afficherSurLaConfirmation.header' | transloco }} <p-sortIcon field="value.afficherSurLaConfirmation" /></th>
        <th pSortableColumn="value.envoiTennaxia" style="width: 10%">{{'referentiels.list.typePrestationProperties.envoiTennaxia.header' | transloco }} <p-sortIcon field="value.envoiTennaxia" /></th>
        <th pSortableColumn="value.unite.designation" style="width: 10%">{{'referentiels.list.typePrestationProperties.unite.header' | transloco }} <p-sortIcon field="value.unite.designation" /></th>
      </tr>
      <tr>
        <th></th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="contains" type="text" field="value.codeHecate" placeholder="--Filtre--" ariaLabel="Filtre par code hecate" />
        </th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="contains" type="text" field="value.designation" placeholder="--Filtre--" ariaLabel="Filtre par désignation" />
        </th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="equals" type="boolean" field="value.transport" placeholder="--Filtre--" ariaLabel="Filtre par transport" />
        </th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="equals" type="boolean" field="value.suffisantPourDemande" placeholder="--Filtre--" ariaLabel="Filtre par suffisant pour demande" />
        </th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="equals" type="boolean" field="value.afficherSurLaConfirmation" placeholder="--Filtre--" ariaLabel="Filtre par afficher sur la confirmation" />
        </th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="equals" type="boolean" field="value.envoiTennaxia" placeholder="--Filtre--" ariaLabel="Filtre par envoi tennaxia" />
        </th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="contains" type="text" field="value.unite.designation" placeholder="--Filtre--" ariaLabel="Filtre par unité" />
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-typePrestation let-index="rowIndex" let-editing="editing">
      <ng-container formArrayName="typePrestationFormArray">
        <tr [formGroupName]="typePrestationFormArray.controls.indexOf(typePrestation)" [pSelectableRow]="typePrestation" [pEditableRow]="typePrestation">
          <td>
            <input id="typePrestationId-{{ index }}" pInputText type="hidden" formControlName="id" />
            <button *ngIf="!editing && userHasReadWritePermission" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-sm" pTooltip="{{ 'button.edit' | transloco }}" (click)="editTypePrestation(typePrestation)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" class="p-button-sm" pTooltip="{{ 'button.validate' | transloco }}" (click)="saveRowTypePrestation(typePrestation)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" class="p-button-sm" pTooltip="{{ 'button.cancel' | transloco }}" (click)="cancelEditRowTypePrestation(typePrestation)"></button>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="codeHecate-{{ index }}" pInputText type="text" formControlName="codeHecate" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ typePrestation.get('codeHecate').value }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="designation-{{ index }}" pInputText type="text" formControlName="designation" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ typePrestation.get('designation').value }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <div class="flex justify-content-center">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-checkbox id="transport-{{ index }}" formControlName="transport" binary="true"> </p-checkbox>
                </ng-template>
                <ng-template pTemplate="output">
                  <i class="pi" [ngClass]="{ 'text-green-700 pi-check-circle': typePrestation.get('transport').value, 'text-red-500 pi-times-circle': !typePrestation.get('transport').value }"></i>
                </ng-template>
              </p-cellEditor>
            </div>
          </td>
          <td>
            <div class="flex justify-content-center">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-checkbox id="suffisantPourDemande-{{ index }}" formControlName="suffisantPourDemande" binary="true"> </p-checkbox>
                </ng-template>
                <ng-template pTemplate="output">
                  <i class="pi" [ngClass]="{ 'text-green-700 pi-check-circle': typePrestation.get('suffisantPourDemande').value, 'text-red-500 pi-times-circle': !typePrestation.get('suffisantPourDemande').value }"></i>
                </ng-template>
              </p-cellEditor>
            </div>
          </td>
          <td>
            <div class="flex justify-content-center">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-checkbox id="afficherSurLaConfirmation-{{ index }}" formControlName="afficherSurLaConfirmation" binary="true"> </p-checkbox>
                </ng-template>
                <ng-template pTemplate="output">
                  <i class="pi" [ngClass]="{ 'text-green-700 pi-check-circle': typePrestation.get('afficherSurLaConfirmation').value, 'text-red-500 pi-times-circle': !typePrestation.get('afficherSurLaConfirmation').value }"></i>
                </ng-template>
              </p-cellEditor>
            </div>
          </td>
          <td>
            <div class="flex justify-content-center">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-checkbox id="envoiTennaxia-{{ index }}" formControlName="envoiTennaxia" binary="true"> </p-checkbox>
                </ng-template>
                <ng-template pTemplate="output">
                  <i class="pi" [ngClass]="{ 'text-green-700 pi-check-circle': typePrestation.get('envoiTennaxia').value, 'text-red-500 pi-times-circle': !typePrestation.get('envoiTennaxia').value }"></i>
                </ng-template>
              </p-cellEditor>
            </div>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-dropdown id="unite-{{ index }}" appendTo="body" [options]="unites" formControlName="unite" optionLabel="designation" dataKey="id" [showClear]="false" placeholder="{{ 'referentiels.list.typePrestationProperties.unite.placeholder' | transloco }}" styleClass="w-full"></p-dropdown>
              </ng-template>
              <ng-template pTemplate="output">
                {{ typePrestation.get('unite').value?.designation }}
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>
</div>

<h3>{{'referentiels.list.prestationProperties.caption' | transloco }}</h3>

@if (userHasReadWritePermission) {
  <div class="flex justify-content-between flex-wrap my-1">
    <div class="flex gap-2">
      <div class="flex justify-content-start gap-2 mb-1">
        <p-button [size]="'small'" label="{{ 'button.add' | transloco }}" pRipple [rounded]="true" class="btn-light" icon="pi pi-plus" (click)="addNewPrestation()" />
      </div>
      <div class="flex justify-content-start gap-2 mb-1">
        <div pTooltip="{{ !lineSelected ? 'Veuillez sélectionner au moins une ligne' : '' }}" tooltipPosition="top">
          <p-button [size]="'small'" pRipple [rounded]="true" label="Contrats associés" class="btn-light" icon="pi pi-save" (click)="viewOrEditContratsAssocieePrestation()" [disabled]="!lineSelected"></p-button>
        </div>
      </div>
    </div>
  </div>
}
<div class="card" [formGroup]="prestationForm">
  <p-table
    [(selection)]="selectedPrestation"
    [rows]="25"
    [rowsPerPageOptions]="[10, 25, 50]"
    [rows]="10"
    (onRowSelect)="onRowSelect($event)"
    (onRowUnselect)="onRowDeselect($event)"
    scrollHeight="400px"
    [value]="prestationFormArray.controls"
    styleClass="p-datatable-striped"
    selectionMode="single"
    editMode="row"
    dataKey="value.id"
    [paginator]="true"
    [totalRecords]="prestationTotalRecords"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{{'jgrid.defaults.recordtext' | transloco}} {first} - {last} {{'jgrid.defaults.recordtextOf' | transloco}} {totalRecords}"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 5%"></th>
        <th pSortableColumn="value.codeHecate" style="width: 10%">{{'referentiels.list.prestationProperties.codeHecate.header' | transloco }} <p-sortIcon field="value.codeHecate" /></th>
        <th pSortableColumn="value.codeTennaxia" style="width: 10%">{{'referentiels.list.prestationProperties.codeTennaxia.header' | transloco }} <p-sortIcon field="value.codeTennaxia" /></th>
        <th pSortableColumn="value.designation" style="width: 15%">{{'referentiels.list.prestationProperties.designation.header' | transloco }} <p-sortIcon field="value.designation" /></th>
        <th pSortableColumn="value.lienDechet" style="width: 15%">{{'referentiels.list.prestationProperties.lienDechet.header' | transloco }} <p-sortIcon field="value.lienDechet" /></th>
        <th pSortableColumn="value.libelleCaracteristiques" style="width: 10%">{{'referentiels.list.prestationProperties.caracteristiques.header' | transloco }} <p-sortIcon field="value.libelleCaracteristiques" /></th>
        <th pSortableColumn="value.codeDR" style="width: 10%">{{'referentiels.list.prestationProperties.codeDR.header' | transloco }} <p-sortIcon field="value.codeDR" /></th>
        <th pSortableColumn="value.typeDesignation" style="width: 10%">{{'referentiels.list.prestationProperties.typePrestation.header' | transloco }} <p-sortIcon field="value.typeDesignation" /></th>
        <th pSortableColumn="value.categorieAchatMosaic" style="width: 10%">{{'referentiels.list.prestationProperties.categorieAchatMosaic.header' | transloco }} <p-sortIcon field="value.categorieAchatMosaic" /></th>
      </tr>
      <tr>
        <th></th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="contains" type="text" field="value.codeHecate" placeholder="--Filtre--" ariaLabel="Filtre par Numéro de demande" />
        </th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="contains" type="text" field="value.codeTennaxia" placeholder="--Filtre--" ariaLabel="Filtre par Date prestée" />
        </th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="contains" type="text" field="value.designation" placeholder="--Filtre--" ariaLabel="Filtre par Déchet" />
        </th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="equals" field="value.lienDechet">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-dropdown [options]="lienDechets" (onChange)="filter($event.value)" placeholder="Lien Déchet" appendTo="body">
                <ng-template let-option pTemplate="item">
                  <span [class]="option.value">{{ option.label }}</span>
                </ng-template>
              </p-dropdown>
            </ng-template>
          </p-columnFilter>
        </th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="contains" type="text" field="value.libelleCaracteristiques" placeholder="--Filtre--" ariaLabel="Filtre par Catégorie outil d'achat" />
        </th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="contains" type="text" field="value.codeDR" placeholder="--Filtre--" ariaLabel="Filtre par Coût" />
        </th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="contains" type="text" field="value.typeDesignation" placeholder="--Filtre--" ariaLabel="Filtre par Coût" />
        </th>
        <th>
          <p-columnFilter [showMenu]="false" [showClearButton]="false" matchMode="contains" type="text" field="value.categorieAchatMosaic" placeholder="--Filtre--" ariaLabel="Filtre par Coût" />
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-prestation let-index="rowIndex" let-editing="editing">
      <ng-container formArrayName="prestationFormArray">
        <tr [formGroupName]="prestationFormArray.controls.indexOf(prestation)" [pEditableRow]="prestation" [pSelectableRow]="prestation">
          <td>
            <input id="prestationId-{{ index }}" pInputText type="hidden" formControlName="id" />
            <button *ngIf="!editing && userHasReadWritePermission" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-sm" pTooltip="{{ 'button.edit' | transloco }}" (click)="editPrestation(prestation)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" class="p-button-sm" pTooltip="{{ 'button.validate' | transloco }}" (click)="saveRowPrestation(prestation)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" class="p-button-sm" pTooltip="{{ 'button.cancel' | transloco }}" (click)="cancelEditRowPrestation(prestation)"></button>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="codeHecate-{{ index }}" pInputText type="text" formControlName="codeHecate" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ prestation.get('codeHecate').value }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="codeTennaxia-{{ index }}" pInputText type="text" formControlName="codeTennaxia" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ prestation.get('codeTennaxia').value }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="designation-{{ index }}" pInputText type="text" formControlName="designation" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ prestation.get('designation').value }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-dropdown id="lienDechet-{{ index }}" appendTo="body" [options]="lienDechets" formControlName="lienDechet"></p-dropdown>
              </ng-template>
              <ng-template pTemplate="output">
                {{ prestation.get('lienDechet').value }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="libelleCaracteristiques-{{ index }}" pInputText type="text" formControlName="libelleCaracteristiques" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ prestation.get('libelleCaracteristiques').value }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="codeDR-{{ index }}" pInputText type="text" formControlName="codeDR" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ prestation.get('codeDR').value }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-dropdown id="typeDesignation-{{ index }}" appendTo="body" [options]="typePrestationResult" optionLabel="designation" optionValue="id" formControlName="typeId"></p-dropdown>
              </ng-template>
              <ng-template pTemplate="output">
                {{ prestation.get('typeDesignation').value }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input id="categorieAchatMosaic-{{ index }}" pInputText type="text" formControlName="categorieAchatMosaic" />
              </ng-template>
              <ng-template pTemplate="output">
                {{ prestation.get('categorieAchatMosaic').value }}
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>
</div>

<p-toast />
